import type { Column } from 'react-data-grid';

/** Key of the presentation-only row-number column (BR-046). Never a field or a paste target. */
export const ROW_NUMBER_KEY = 'rowNumber';

/**
 * An Excel-style row-number column: the first, frozen column, so it stays on the right edge in RTL
 * while the grid scrolls sideways. It shows the 1-based position in the current visible order
 * (after sorting and filtering; react-data-grid passes that index, also under virtualization),
 * highlights the active row, and carries the row's state for screen readers. It is not editable,
 * not sortable, and not resizable.
 */
export function rowNumberColumn<R>(
  activeRow: number,
  describe: (row: R) => { readonly tone: string; readonly label: string | null },
): Column<R> {
  return {
    key: ROW_NUMBER_KEY,
    name: '#',
    width: 52,
    frozen: true,
    resizable: false,
    sortable: false,
    headerCellClass: 'gutter gutter--header',
    renderHeaderCell: () => (
      <span>
        <span aria-hidden="true">#</span>
        <span className="visually-hidden">מספר שורה</span>
      </span>
    ),
    cellClass: (row) => `gutter gutter--${describe(row).tone}`,
    renderCell: ({ row, rowIdx }) => {
      const { label } = describe(row);
      return (
        <span
          className={
            rowIdx === activeRow ? 'gutter__number gutter__number--active' : 'gutter__number'
          }
          aria-current={rowIdx === activeRow ? 'true' : undefined}
        >
          {rowIdx + 1}
          {label !== null && <span className="visually-hidden"> ({label})</span>}
        </span>
      );
    },
  };
}
